export default "__VITE_ASSET__YCxg8LEq__"